import { Component, Input } from '@angular/core'

@Component({
    selector: 'mg-social-media-links',
    templateUrl: './social-media-links.component.html',
    styleUrls: ['./social-media-links.component.scss'],
})
export class SocialMediaLinksComponent {
    @Input() newsletter: string = ''
    @Input() facebook: string = ''
    @Input() instagram: string = ''
    @Input() linkedin: string = ''
    @Input() twitter: string = ''
}
